import React from 'react';
import LegalLayout, {
  LegalSection,
  LegalParagraph,
  LegalList
} from './LegalLayout';

const TermsConditions = () => (
  <LegalLayout
    title="Terms & Conditions"
    effectiveDate="Effective from 1 June 2026"
    pageTestId="terms-conditions-page"
  >
    <LegalParagraph>
      Welcome to Read Right Academy. By accessing our website, enrolling in our
      programmes, or downloading our materials, you agree to the terms below.
      Please read them carefully.
    </LegalParagraph>

    <LegalSection heading="1. About Us">
      <LegalParagraph>
        Read Right Academy is an early childhood literacy service founded by
        Kalah K. Singam, offering online phonics and early reading programmes
        for children, as well as training and guidance for parents, teachers,
        and aspiring educators.
      </LegalParagraph>
    </LegalSection>

    <LegalSection heading="2. Use of the Website">
      <LegalList
        items={[
          'You may browse and use this website for personal, non-commercial purposes.',
          'You may not copy, reproduce, or republish content from this website without our written permission.',
          'You agree not to use the website for any unlawful purpose or in a way that may harm the site, its users, or our reputation.'
        ]}
      />
    </LegalSection>

    <LegalSection heading="3. Programmes and Enrolment">
      <LegalParagraph>
        Enrolling in a Read Right Academy programme requires confirmation from
        our team. Once a place is offered, you must complete enrolment and any
        agreed payment within the timeframe communicated to you.
      </LegalParagraph>
      <LegalList
        items={[
          'Programme content, schedules and group sizes may be adjusted to suit the cohort.',
          'We reserve the right to recommend an alternative programme if it better matches your child\'s readiness or learning needs.',
          'We may decline or end an enrolment if the programme is not the right fit, with proportionate refund where applicable.'
        ]}
      />
    </LegalSection>

    <LegalSection heading="4. Intellectual Property">
      <LegalParagraph>
        All content on this website and within our programmes — including
        lesson materials, the 5-Day Phonics Starter Guide, articles, photos,
        graphics, logos, and methodology — is the intellectual property of Read
        Right Academy and Kalah K. Singam.
      </LegalParagraph>
      <LegalList
        items={[
          'You may use materials we share with you for your own personal or family use.',
          'You may not copy, redistribute, sell, or teach our materials to others without our written permission.',
          'Teachers and educators interested in delivering our content may apply for our Phonics Teacher Training programme.'
        ]}
      />
    </LegalSection>

    <LegalSection heading="5. Parent &amp; Student Responsibilities">
      <LegalList
        items={[
          'Ensure your child has a quiet space, a working device, and a stable internet connection during online classes.',
          'Support your child by attending class on time and following any home practice suggestions shared by the teacher.',
          'Communicate openly with us about your child\'s progress, concerns, or any changes in learning needs.'
        ]}
      />
    </LegalSection>

    <LegalSection heading="6. Limitation of Liability">
      <LegalParagraph>
        Read Right Academy is committed to delivering high-quality, child-centred
        teaching. However, we cannot guarantee specific learning outcomes, as
        every child develops at their own pace. We are not liable for any
        indirect or consequential losses arising from the use of this website
        or our programmes.
      </LegalParagraph>
    </LegalSection>

    <LegalSection heading="7. Changes to These Terms">
      <LegalParagraph>
        We may update these Terms &amp; Conditions from time to time. Continued
        use of our website or programmes after changes are posted means you
        accept the updated terms.
      </LegalParagraph>
    </LegalSection>
  </LegalLayout>
);

export default TermsConditions;
